// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CounterStrikeHomePage__root--aMqFA {
    position: relative;
    background: #090A0E;
    overflow: hidden;
}

.CounterStrikeHomePage__headerWrap--P9A8O {
    height: 88px;
    border-bottom: 1px solid #1E2028;
    margin-bottom: 24px;
    width: 100%;
}

@media screen and (max-width: 1023px) {

.CounterStrikeHomePage__headerWrap--P9A8O {
        padding-left: 24px;
        padding-right: 24px
}
    }

@media screen and (min-width: 1024px) and (max-width: 1381px) {

.CounterStrikeHomePage__headerWrap--P9A8O {
        padding-left: 40px;
        padding-right: 40px
}
    }

@media screen and (min-width: 1024px) {

.CounterStrikeHomePage__headerWrap--P9A8O {
        margin-bottom: 60px
}
    }

.CounterStrikeHomePage__header--_K8MK {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    max-width: 1320px;
    margin: 0 auto;
}

.CounterStrikeHomePage__logo--sez2p img {
    width: 137px;
    height: 32px;
}

.CounterStrikeHomePage__main--FWjTH {
    max-width: 1320px;
    width: 100%;
    margin: 0 auto;
}

@media screen and (max-width: 1023px) {

.CounterStrikeHomePage__main--FWjTH {
        padding-left: 24px;
        padding-right: 24px
}
    }

@media screen and (min-width: 1024px) and (max-width: 1381px) {

.CounterStrikeHomePage__main--FWjTH {
        padding-left: 40px;
        padding-right: 40px
}
    }

.CounterStrikeHomePage__title--yNQEU {
    font-size: 24px;
    line-height: 28px;
    font-weight: 500;
    color: var(--tertiary-color);
    text-transform: uppercase;
    margin-bottom: 28px;
}

@media screen and (min-width: 1024px) {

.CounterStrikeHomePage__title--yNQEU {
        font-size: 40px;
        line-height: 1.15;
        margin-bottom: 40px
}
    }

.CounterStrikeHomePage__secondaryTitle--PgNLf {
    font-weight: 500;
    font-size: 20px;
    line-height: 1.2;
    margin-bottom: 28px;
    color: var(--tertiary-color);
}

@media screen and (min-width: 1024px) {

.CounterStrikeHomePage__secondaryTitle--PgNLf {
        font-size: 28px;
        line-height: 1.14
}
    }

.CounterStrikeHomePage__secondaryTitleWithCenter--xuvUC {
    text-align: center;
    margin-bottom: 40px;
}

.CounterStrikeHomePage__section--ONeHH {
    position: relative;
    margin-bottom: 60px;
    z-index: 2;
}

.CounterStrikeHomePage__description--kBKNf {
    color: var(--tertiary-color);
    margin-bottom: 40px;
    text-align: center;
}

@media screen and (min-width: 1024px) {

.CounterStrikeHomePage__description--kBKNf {
        margin: 0 auto 60px;
        max-width: 420px
}
    }

.CounterStrikeHomePage__sectionGrid--Jt3Nd {
    display: grid;
}

@media screen and (max-width: 1023px), screen and (min-width: 1024px) and (max-width: 1381px) {

.CounterStrikeHomePage__sectionGrid--Jt3Nd {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: repeat(3, max-content);
        grid-template-areas: "sectionInfo sectionInfo"
                            "sectionImage sectionImage"
                            "sectionCopyrightInfo sectionCopyrightInfo"
}
    }

@media screen and (min-width: 1380px) {

.CounterStrikeHomePage__sectionGrid--Jt3Nd {
        grid-template-columns: auto 760px;
        grid-template-rows: repeat(2, max-content);
        grid-column-gap: 24px;
        grid-template-areas: "sectionInfo sectionImage"
                            "sectionCopyrightInfo sectionImage"
}
    }

.CounterStrikeHomePage__sectionGrid--Jt3Nd .CounterStrikeHomePage__sectionInfo--pUpUq {
        grid-area: sectionInfo;
    }

.CounterStrikeHomePage__sectionGrid--Jt3Nd .CounterStrikeHomePage__sectionCopyrightInfo--cJTy2 {
        grid-area: sectionCopyrightInfo;
    }

.CounterStrikeHomePage__sectionGrid--Jt3Nd .CounterStrikeHomePage__sectionImage--pyrWL {
        grid-area: sectionImage;
    }

.CounterStrikeHomePage__sectionGridButton--b3sWx {
    margin-bottom: 40px;
}

@media screen and (max-width: 1023px) {

.CounterStrikeHomePage__sectionGridButton--b3sWx {
        width: 100%
}
    }

@media screen and (max-width: 518px) {

.CounterStrikeHomePage__sectionFlexLink--c8uoC {
        width: 100%;
        margin-bottom: 20px
}
    }

@media screen and (min-width: 1024px) and (max-width: 1381px) {

.CounterStrikeHomePage__sectionFlexLink--c8uoC {
        margin-bottom: 40px
}
    }

.CounterStrikeHomePage__sectionLink--Rduub {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color 0.25s ease-in-out, background-color 0.25s ease-in-out;
    white-space: nowrap;
    text-transform: uppercase;
    padding: 12px 48px;
    background-color: var(--main-color);
    color: #111319;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.02em;
}

@media (hover: hover) and (pointer: fine) {
        .CounterStrikeHomePage__sectionLink--Rduub:hover, .CounterStrikeHomePage__sectionLink--Rduub:active {
            background-color: var(--secondary-color);
            color: #1E2028;
        }
    }

.CounterStrikeHomePage__sectionFlexButtonWrap--lysUl {
    display: flex;
    gap: 16px;
    align-items: center;
}

@media screen and (max-width: 518px) {

.CounterStrikeHomePage__sectionFlexButtonWrap--lysUl {
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 20px
}

        .CounterStrikeHomePage__sectionFlexButtonWrap--lysUl > button {
            width: 100%;
        }
    }

@media screen and (min-width: 768px) and (max-width: 1024px), screen and (min-width: 1024px) and (max-width: 1381px) {

.CounterStrikeHomePage__sectionFlexButtonWrap--lysUl {
        margin-bottom: 40px
}
    }

.CounterStrikeHomePage__sectionFlexButtonWrapText--oueTE {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.05em;
    color: var(--secondary-color);
    text-transform: uppercase;
}

@media screen and (min-width: 1380px) {

.CounterStrikeHomePage__sectionFlex--WVEya {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 24px
}
    }

.CounterStrikeHomePage__sectionColumn--ayREv {
    padding: 0 0 60px 0;
}

@media screen and (min-width: 1024px) {

.CounterStrikeHomePage__sectionColumn--ayREv {
        padding: 60px 0
}
    }

.CounterStrikeHomePage__sectionColumnInOnboarding--QDobp {
    padding: 0 0 60px 0;
}

.CounterStrikeHomePage__sectionCopyrightInfo--cJTy2 {
    font-weight: 400;
    font-size: 12px;
    line-height: 1.33;
    color: #85909D;
    border-top: 1px solid #1E2028;
    padding-top: 16px;
}

@media screen and (max-width: 1023px) {

.CounterStrikeHomePage__sectionCopyrightInfo--cJTy2 {
        margin-top: 20px
}
    }

@media screen and (min-width: 1024px) and (max-width: 1381px) {

.CounterStrikeHomePage__sectionCopyrightInfo--cJTy2 {
        margin-top: 40px
}
    }

.CounterStrikeHomePage__sectionLabel--pMLa6 {
    font-size: 16px;
    line-height: 1.25;
    font-weight: 400;
    color: var(--tertiary-color);
    margin-bottom: 40px;
}

@media screen and (min-width: 1380px) {

.CounterStrikeHomePage__sectionLabel--pMLa6 {
        margin-bottom: 64px
}
    }

.CounterStrikeHomePage__sectionImageWrap--EQnqY,
.CounterStrikeHomePage__sectionVideoWrap--EJb4o {
    width: 100%;
    position: relative;
}

@media screen and (min-width: 1380px) {

.CounterStrikeHomePage__sectionImageWrap--EQnqY,
.CounterStrikeHomePage__sectionVideoWrap--EJb4o {
        width: 760px;
        height: 468px;
        flex-shrink: 0
}
    }

.CounterStrikeHomePage__sectionImage--pyrWL {
    width: 100%;
    height: auto;
    aspect-ratio: 7.6 / 4.68;
}

@media screen and (min-width: 1380px) {

.CounterStrikeHomePage__sectionImage--pyrWL {
        width: 760px;
        height: 468px
}
    }

.CounterStrikeHomePage__list--g2cmZ {
    margin-bottom: 40px;
}

@media screen and (min-width: 1024px) {

.CounterStrikeHomePage__list--g2cmZ {
        padding-right: 30px
}
    }

.CounterStrikeHomePage__listItem--INeXY {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #85909D;
    display: flex;
    gap: 4px;
}

.CounterStrikeHomePage__listItemNumber--pVf7R {
    color: var(--secondary-color);
    width: 26px;
    display: inline-flex;
    flex-shrink: 0;
}

.CounterStrikeHomePage__textWithAnimation1--JjuAv {
    border-radius: 3px;
    padding: 2px;
    animation: CounterStrikeHomePage__colorTransition1--Z5J6v 14.4s ease-in-out infinite;
}

.CounterStrikeHomePage__textWithAnimation2--x4QXn {
    border-radius: 3px;
    padding: 2px;
    animation: CounterStrikeHomePage__colorTransition2--btLby 14.4s ease-in-out infinite;
}

.CounterStrikeHomePage__textWithAnimation3--hxCjO {
    border-radius: 3px;
    padding: 2px;
    animation: CounterStrikeHomePage__colorTransition3--wJRon 14.4s ease-in-out infinite;
}

.CounterStrikeHomePage__textWithAnimation4--MBCXX {
    border-radius: 3px;
    padding: 2px;
    animation: CounterStrikeHomePage__colorTransition4--EPaDy 14.4s ease-in-out infinite;
}

.CounterStrikeHomePage__textWithAnimation5--XS7eL {
    border-radius: 3px;
    padding: 2px;
    animation: CounterStrikeHomePage__colorTransition5--oP8Sf 14.4s ease-in-out infinite;
}

.CounterStrikeHomePage__textWithAnimation6--kkTMv {
    border-radius: 3px;
    padding: 2px;
    animation: CounterStrikeHomePage__colorTransition6--vrnwc 14.4s ease-in-out infinite;
}

.CounterStrikeHomePage__textWithAnimation7--gHsqf {
    border-radius: 3px;
    padding: 2px;
    animation: CounterStrikeHomePage__colorTransition7--gbxko 14.4s ease-in-out infinite;
}

.CounterStrikeHomePage__textWithAnimation8--HrgDI {
    border-radius: 3px;
    padding: 2px;
    animation: CounterStrikeHomePage__colorTransition8--ekYED 14.4s ease-in-out infinite;
}

@keyframes CounterStrikeHomePage__colorTransition1--Z5J6v {
    0% {
        background-color: transparent;
        color: #85909D;
    }
    1.4% {
        color: #090A0E;
        background-color: #ffffff;
    }
    11.1% {
        background-color: #ffffff;
        color: #090A0E;
    }
    12.5% {
        background-color: transparent;
        color: #85909D;
    }
}

@keyframes CounterStrikeHomePage__colorTransition2--btLby {
    12.5% {
        background-color: transparent;
        color: #85909D;
    }
    13.9% {
        color: #090A0E;
        background-color: #ffffff;
    }
    23.6% {
        color: #090A0E;
        background-color: #ffffff;
    }
    25% {
        background-color: transparent;
        color: #85909D;
    }
}

@keyframes CounterStrikeHomePage__colorTransition3--wJRon {
    25% {
        background-color: transparent;
        color: #85909D;
    }
    26.4% {
        color: #090A0E;
        background-color: #ffffff;
    }
    36.1% {
        color: #090A0E;
        background-color: #ffffff;
    }
    37.5% {
        background-color: transparent;
        color: #85909D;
    }
}

@keyframes CounterStrikeHomePage__colorTransition4--EPaDy {
    37.5% {
        background-color: transparent;
        color: #85909D;
    }
    38.9% {
        color: #090A0E;
        background-color: #ffffff;
    }
    48.6% {
        color: #090A0E;
        background-color: #ffffff;
    }
    50% {
        background-color: transparent;
        color: #85909D;
    }
}

@keyframes CounterStrikeHomePage__colorTransition5--oP8Sf {
    50% {
        background-color: transparent;
        color: #85909D;
    }
    51.4% {
        color: #090A0E;
        background-color: #ffffff;
    }
    61.1% {
        color: #090A0E;
        background-color: #ffffff;
    }
    62.5% {
        background-color: transparent;
        color: #85909D;
    }
}

@keyframes CounterStrikeHomePage__colorTransition6--vrnwc {
    62.5% {
        background-color: transparent;
        color: #85909D;
    }
    63.9% {
        color: #090A0E;
        background-color: #ffffff;
    }
    73.6% {
        color: #090A0E;
        background-color: #ffffff;
    }
    75% {
        background-color: transparent;
        color: #85909D;
    }
}

@keyframes CounterStrikeHomePage__colorTransition7--gbxko {
    75% {
        background-color: transparent;
        color: #85909D;
    }
    76.4% {
        color: #090A0E;
        background-color: #ffffff;
    }
    86.1% {
        color: #090A0E;
        background-color: #ffffff;
    }
    87.5% {
        background-color: transparent;
        color: #85909D;
    }
}

@keyframes CounterStrikeHomePage__colorTransition8--ekYED {
    87.5% {
        background-color: transparent;
        color: #85909D;
    }
    88.9% {
        color: #090A0E;
        background-color: #ffffff;
    }
    98.6% {
        color: #090A0E;
        background-color: #ffffff;
    }
    100% {
        background-color: transparent;
        color: #85909D;
    }
}

.CounterStrikeHomePage__tournamentList--MJWCk {
    display: grid;
    grid-gap: 24px;
    grid-template-columns: repeat(4, minmax(312px, 1fr));
    width: 100%;
    scroll-snap-type: x mandatory;
    overflow-x: auto;
    min-height: 244px;
}

@media screen and (max-width: 518px) {

.CounterStrikeHomePage__tournamentList--MJWCk {
        grid-template-columns: repeat(4, minmax(275px, 1fr));
        grid-gap: 20px
}
    }

.CounterStrikeHomePage__tournamentList--MJWCk::-webkit-scrollbar {
        display: none;
    }

/* masonryList */
@media screen and (min-width: 768px) and (max-width: 1024px), screen and (min-width: 1024px) and (max-width: 1381px) {
.CounterStrikeHomePage__masonryList--vtYIW {
        -moz-column-count: 2;
             column-count: 2;
        -moz-column-gap: 24px;
             column-gap: 24px
}
    }
@media screen and (min-width: 1380px) {
.CounterStrikeHomePage__masonryList--vtYIW {
        -moz-column-count: 4;
             column-count: 4;
        -moz-column-gap: 24px;
             column-gap: 24px
}
    }

.CounterStrikeHomePage__masonryCard--T1HSE {
    background-color: #090A0E;
    border: 1px solid #1E2028;
    border-radius: 6px;
    padding: 24px;
}

@media screen and (min-width: 768px) and (max-width: 1024px), screen and (min-width: 1024px) {

.CounterStrikeHomePage__masonryCard--T1HSE {
        -moz-column-break-inside: avoid;
             break-inside: avoid
}
    }

.CounterStrikeHomePage__questionAnswerBlock--eqT5L {
    margin-bottom: 24px;
}

.CounterStrikeHomePage__masonryCardLabel--qFWvp {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 16px;
    color: var(--tertiary-color);
}

.CounterStrikeHomePage__masonryCardValue--oRPdI {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.71;
    color: #85909D;
}

.CounterStrikeHomePage__masonryCardLink--D3bVQ {
    width: 100%;
}

/* slider */
.CounterStrikeHomePage__bullet--mmqVO {
    width: 32px;
    height: 2px;
    border-radius: 6px;
    background-color: var(--secondary-color);
    opacity: 1;
    transition: width 0.4s ease-in-out;
    position: relative;
    cursor: pointer;
}
.CounterStrikeHomePage__bullet--mmqVO::after {
        content: "";
        position: absolute;
        left: 0;
        top: -8px;
        width: 100%;
        height: 18px;
        background-color: transparent;
        z-index: 2;
    }

.CounterStrikeHomePage__bulletActive--huBXu {
    width: 140px;
}

.CounterStrikeHomePage__glow--_dRW6 {
    position: absolute;
    width: 539px;
    height: 539px;
    z-index: -1;
}

@media screen and (max-width: 1023px), screen and (min-width: 1024px) and (max-width: 1381px) {

.CounterStrikeHomePage__glow--_dRW6 {
        bottom: 0;
        right: 50%;
        transform: translateX(50%)
}
    }

@media screen and (max-width: 518px) {

.CounterStrikeHomePage__glow--_dRW6 {
        bottom: -100px;
        transform: none;
        right: -300px
}
    }

@media screen and (min-width: 1380px) {

.CounterStrikeHomePage__glow--_dRW6 {
        top: 0;
        right: -100px
}
    }

.CounterStrikeHomePage__glowBlock--_pDaO {
    width: 365px;
    height: 365px;
    border-radius: 50%;
    background: linear-gradient(180deg, #FFBF4E 43.75%, #FF5B00 52.6%);
    filter: blur(50px);
    will-change: filter;
    position: absolute;
    z-index: -1;
}

@media screen and (max-width: 1023px), screen and (min-width: 1024px) and (max-width: 1381px) {

.CounterStrikeHomePage__glowBlock--_pDaO {
        bottom: 87px;
        right: 50%;
        transform: translateX(50%)
}
    }

@media screen and (max-width: 518px) {

.CounterStrikeHomePage__glowBlock--_pDaO {
        bottom: -13px;
        transform: none;
        right: -213px
}
    }

@media screen and (min-width: 1380px) {

.CounterStrikeHomePage__glowBlock--_pDaO {
        top: 87px;
        right: -13px
}
    }

.CounterStrikeHomePage__refererPrimaryGlow--PC93b {
    position: absolute;
    display: none;
    z-index: -1;
}

@media screen and (min-width: 1024px) {

.CounterStrikeHomePage__refererPrimaryGlow--PC93b {
        width: 273px;
        height: 273px;
        bottom: -99px;
        left: 111px;
        display: block
}
    }

.CounterStrikeHomePage__refererSecondaryGlow--ddUYK {
    position: absolute;
    width: 320px;
    height: 320px;
    top: 0px;
    right: -30px;
    z-index: -1;
}

@media screen and (min-width: 1024px) {

.CounterStrikeHomePage__refererSecondaryGlow--ddUYK {
        width: 151px;
        height: 151px;
        top: 78px;
        right: 187px
}
    }

.CounterStrikeHomePage__videoGlow--RQo7h {
    position: absolute;
    width: 320px;
    height: 320px;
    z-index: -1;
}

@media screen and (max-width: 1023px) {

.CounterStrikeHomePage__videoGlow--RQo7h {
        bottom: -90px;
        right: -110px
}
    }

@media screen and (min-width: 1024px) {

.CounterStrikeHomePage__videoGlow--RQo7h {
        width: 205px;
        height: 205px;
        bottom: -60px;
        left: -114px
}
    }

/* onboarding slider */
.CounterStrikeHomePage__onboardingBlock--hZnnY {
    background: #1E2028;
    border-radius: 6px;
    position: relative;
    overflow: hidden;
}

.CounterStrikeHomePage__onboardingBlockTitle--f6heH {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: var(--tertiary-color);
    position: absolute;
    top: 24px;
    left: 24px;
    z-index: 4;
}

@media screen and (min-width: 768px) and (max-width: 1024px), screen and (min-width: 1024px) {

.CounterStrikeHomePage__onboardingBlockTitle--f6heH {
        font-size: 28px;
        line-height: 32px
}
    }

@media screen and (min-width: 768px) and (max-width: 1024px) {

.CounterStrikeHomePage__onboardingBlockTitle--f6heH {
        width: 260px
}
    }

@media screen and (min-width: 1380px) {

.CounterStrikeHomePage__onboardingBlockTitle--f6heH {
        top: 48px;
        left: 48px
}
    }

.CounterStrikeHomePage__onboardingBlockPagination--gEGYG {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    position: absolute;
    padding: 8px;
    background-color: #111319;
    border-radius: 16px;
    left: 50% !important;
    transform: translateX(-50%);
    bottom: 24px !important;
    width: auto !important;
    z-index: 4;
}

@media screen and (min-width: 768px) and (max-width: 1024px), screen and (min-width: 1024px) and (max-width: 1381px) {

.CounterStrikeHomePage__onboardingBlockPagination--gEGYG {
        left: 24px !important;
        transform: none
}
    }

@media screen and (min-width: 1380px) {

.CounterStrikeHomePage__onboardingBlockPagination--gEGYG {
        left: 48px !important;
        bottom: 48px !important;
        transform: none
}
    }

.CounterStrikeHomePage__buttonPlay--rH0H4 {
    color: var(--darkest-color);
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.32px;
    padding: 20px 64px;
    gap: 8px;
    border-radius: 12px;
    --icon-size: 16px;
}

/* footer */

.CounterStrikeHomePage__footerWrapper--DT4kA {
    width: 100%;
    position: relative;
    z-index: 2;
}

@media screen and (max-width: 1023px) {

.CounterStrikeHomePage__footerWrapper--DT4kA {
        padding-left: 24px;
        padding-right: 24px
}
    }

@media screen and (min-width: 1024px) and (max-width: 1381px) {

.CounterStrikeHomePage__footerWrapper--DT4kA {
        padding-left: 40px;
        padding-right: 40px
}
    }

@media screen and (min-width: 768px) and (max-width: 1024px), screen and (min-width: 1024px) {

.CounterStrikeHomePage__footerWrapper--DT4kA {
        padding-top: 60px;
        padding-bottom: 60px
}
    }

.CounterStrikeHomePage__footerGlow--VGC7t {
    position: absolute;
    z-index: -1;
}

@media screen and (max-width: 518px) {

.CounterStrikeHomePage__footerGlow--VGC7t {
        width: 337px;
        height: 337px;
        right: -192px;
        bottom: -180px
}
    }

@media screen and (min-width: 768px) and (max-width: 1024px) {

.CounterStrikeHomePage__footerGlow--VGC7t {
        width: 400px;
        height: 400px;
        left: 0;
        bottom: -250px
}
    }

@media screen and (min-width: 1024px) {

.CounterStrikeHomePage__footerGlow--VGC7t {
        width: 273px;
        height: 273px;
        left: 0;
        bottom: -134px
}
    }

.CounterStrikeHomePage__footer--lZvIy {
    max-width: 1320px;
    margin: 0 auto;
}

@media screen and (min-width: 768px) and (max-width: 1024px), screen and (min-width: 1024px) {

.CounterStrikeHomePage__footer--lZvIy {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-gap: 20px
}
    }

@media screen and (max-width: 1023px) {

.CounterStrikeHomePage__footerBlock--RV6ES {
        margin-bottom: 20px
}
    }

.CounterStrikeHomePage__footerSubTitle--Yxfph {
    font-weight: 500;
    font-size: 20px;
    line-height: 1.2;
    color: var(--tertiary-color);
    margin-bottom: 24px;
}

.CounterStrikeHomePage__footerMenuItem--hZ0GH {
    color: var(--tertiary-color);
    font-weight: 400;
    font-size: 14px;
    line-height: 1.71;
    display: block;
}

.CounterStrikeHomePage__footerMenuItem--hZ0GH:not(:last-child) {
        margin-bottom: 16px;
    }

.CounterStrikeHomePage__footerLabel--jfDil {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #85909D;
    display: block;
}

.CounterStrikeHomePage__footerCopyright--nkj02 {
    margin-bottom: 16px;
    margin-top: 24px;
}

.CounterStrikeHomePage__footerLabelWithIndent--Ja5Ui {
    margin-bottom: 32px;
}

.CounterStrikeHomePage__legalDisclaimerText--fjVOc {
    color: #85909D;
    text-transform: uppercase;
    margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/ui-v2/pages/CounterStrikeHomePage/CounterStrikeHomePage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;IACnB,WAAW;AAef;;AAbI;;AANJ;QAOQ,kBAAkB;QAClB;AAWR;IAVI;;AAEA;;AAXJ;QAYQ,kBAAkB;QAClB;AAMR;IALI;;AAEA;;AAhBJ;QAiBQ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,cAAc;AAWlB;;AATI;;AALJ;QAMQ,kBAAkB;QAClB;AAOR;IANI;;AAEA;;AAVJ;QAWQ,kBAAkB;QAClB;AAER;IADI;;AAGJ;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;AAOvB;;AALI;;AARJ;QASQ,eAAe;QACf,iBAAiB;QACjB;AAER;IADI;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;AAMhC;;AAJI;;AAPJ;QAQQ,eAAe;QACf;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;AAMtB;;AAJI;;AALJ;QAMQ,mBAAmB;QACnB;AAER;IADI;;AAGJ;IACI,aAAa;AA6BjB;;AA3BI;;AAHJ;QAIQ,8BAA8B;QAC9B,0CAA0C;QAC1C;;;AAwBR;IArBI;;AAEA;;AAXJ;QAYQ,iCAAiC;QACjC,0CAA0C;QAC1C,qBAAqB;QACrB;;AAeR;IAbI;;AAEA;QACI,sBAAsB;IAC1B;;AAEA;QACI,+BAA+B;IACnC;;AAEA;QACI,uBAAuB;IAC3B;;AAGJ;IACI,mBAAmB;AAKvB;;AAHI;;AAHJ;QAIQ;AAER;IADI;;AAIA;;AADJ;QAEQ,WAAW;QACX;AAMR;IALI;;AAEA;;AANJ;QAOQ;AAER;IADI;;AAGJ;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,uEAAuE;IACvE,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,mCAAmC;IACnC,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAQ1B;;AANI;QACI;YACI,wCAAwC;YACxC,cAAc;QAClB;IACJ;;AAGJ;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AAevB;;AAbI;;AALJ;QAMQ,sBAAsB;QACtB,uBAAuB;QACvB;AAUR;;QARQ;YACI,WAAW;QACf;IACJ;;AAEA;;AAfJ;QAgBQ;AAER;IADI;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAGI;;AADJ;QAEQ,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B;AAER;IADI;;AAGJ;IACI,mBAAmB;AAKvB;;AAHI;;AAHJ;QAIQ;AAER;IADI;;AAGJ;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,6BAA6B;IAC7B,iBAAiB;AASrB;;AAPI;;AARJ;QASQ;AAMR;IALI;;AAEA;;AAZJ;QAaQ;AAER;IADI;;AAGJ;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;AAKvB;;AAHI;;AAPJ;QAQQ;AAER;IADI;;AAGJ;;IAEI,WAAW;IACX,kBAAkB;AAOtB;;AALI;;AALJ;;QAMQ,YAAY;QACZ,aAAa;QACb;AAER;IADI;;AAGJ;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;AAM5B;;AAJI;;AALJ;QAMQ,YAAY;QACZ;AAER;IADI;;AAGJ;IACI,mBAAmB;AAKvB;;AAHI;;AAHJ;QAIQ;AAER;IADI;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,oFAAsD;AAC1D;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,oFAAsD;AAC1D;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,oFAAsD;AAC1D;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,oFAAsD;AAC1D;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,oFAAsD;AAC1D;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,oFAAsD;AAC1D;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,oFAAsD;AAC1D;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,oFAAsD;AAC1D;;AAEA;IACI;QACI,6BAA6B;QAC7B,cAAc;IAClB;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,yBAAyB;QACzB,cAAc;IAClB;IACA;QACI,6BAA6B;QAC7B,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,cAAc;IAClB;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,6BAA6B;QAC7B,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,cAAc;IAClB;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,6BAA6B;QAC7B,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,cAAc;IAClB;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,6BAA6B;QAC7B,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,cAAc;IAClB;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,6BAA6B;QAC7B,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,cAAc;IAClB;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,6BAA6B;QAC7B,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,cAAc;IAClB;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,6BAA6B;QAC7B,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,cAAc;IAClB;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,6BAA6B;QAC7B,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,oDAAoD;IACpD,WAAW;IACX,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;AAUrB;;AARI;;AATJ;QAUQ,oDAAoD;QACpD;AAMR;IALI;;AAEA;QACI,aAAa;IACjB;;AAGJ,gBAAgB;AAEZ;AADJ;QAEQ,oBAAe;aAAf,eAAe;QACf,qBAAgB;aAAhB;AAOR;IANI;AAEA;AANJ;QAOQ,oBAAe;aAAf,eAAe;QACf,qBAAgB;aAAhB;AAER;IADI;;AAGJ;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AAKjB;;AAHI;;AANJ;QAOQ,+BAAmB;aAAnB;AAER;IADI;;AAGJ;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA,WAAW;AACX;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,wCAAwC;IACxC,UAAU;IACV,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;AAYnB;AAVI;QACI,WAAW;QACX,kBAAkB;QAClB,OAAO;QACP,SAAS;QACT,WAAW;QACX,YAAY;QACZ,6BAA6B;QAC7B,UAAU;IACd;;AAGJ;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;AAkBf;;AAhBI;;AANJ;QAOQ,SAAS;QACT,UAAU;QACV;AAaR;IAZI;;AAEA;;AAZJ;QAaQ,cAAc;QACd,eAAe;QACf;AAOR;IANI;;AAEA;;AAlBJ;QAmBQ,MAAM;QACN;AAER;IADI;;AAGJ;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kEAAkE;IAClE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AAkBf;;AAhBI;;AAVJ;QAWQ,YAAY;QACZ,UAAU;QACV;AAaR;IAZI;;AAEA;;AAhBJ;QAiBQ,aAAa;QACb,eAAe;QACf;AAOR;IANI;;AAEA;;AAtBJ;QAuBQ,SAAS;QACT;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AASf;;AAPI;;AALJ;QAMQ,YAAY;QACZ,aAAa;QACb,aAAa;QACb,WAAW;QACX;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,WAAW;AAQf;;AANI;;AARJ;QASQ,YAAY;QACZ,aAAa;QACb,SAAS;QACT;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;AAaf;;AAXI;;AANJ;QAOQ,aAAa;QACb;AASR;IARI;;AAEA;;AAXJ;QAYQ,YAAY;QACZ,aAAa;QACb,aAAa;QACb;AAER;IADI;;AAGJ,sBAAsB;AACtB;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;AAed;;AAbI;;AAVJ;QAWQ,eAAe;QACf;AAWR;IAVI;;AAEA;;AAfJ;QAgBQ;AAOR;IANI;;AAEA;;AAnBJ;QAoBQ,SAAS;QACT;AAER;IADI;;AAGJ;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,2BAA2B;IAC3B,uBAAuB;IACvB,sBAAsB;IACtB,UAAU;AAYd;;AAVI;;AAfJ;QAgBQ,qBAAqB;QACrB;AAQR;IAPI;;AAEA;;AApBJ;QAqBQ,qBAAqB;QACrB,uBAAuB;QACvB;AAER;IADI;;AAGJ;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,WAAW;;AAEX;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;AAgBd;;AAdI;;AALJ;QAMQ,kBAAkB;QAClB;AAYR;IAXI;;AAEA;;AAVJ;QAWQ,kBAAkB;QAClB;AAOR;IANI;;AAEA;;AAfJ;QAgBQ,iBAAiB;QACjB;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,WAAW;AAsBf;;AApBI;;AAJJ;QAKQ,YAAY;QACZ,aAAa;QACb,aAAa;QACb;AAgBR;IAfI;;AAEA;;AAXJ;QAYQ,YAAY;QACZ,aAAa;QACb,OAAO;QACP;AASR;IARI;;AAEA;;AAlBJ;QAmBQ,YAAY;QACZ,aAAa;QACb,OAAO;QACP;AAER;IADI;;AAGJ;IACI,iBAAiB;IACjB,cAAc;AAOlB;;AALI;;AAJJ;QAKQ,aAAa;QACb,sCAAsC;QACtC;AAER;IADI;;AAIA;;AADJ;QAEQ;AAER;IADI;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAKlB;;AAHI;QACI,mBAAmB;IACvB;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB","sourcesContent":[".root {\n    position: relative;\n    background: #090A0E;\n    overflow: hidden;\n}\n\n.headerWrap {\n    height: 88px;\n    border-bottom: 1px solid #1E2028;\n    margin-bottom: 24px;\n    width: 100%;\n\n    @media (--mobile) {\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n\n    @media (--tablet) {\n        padding-left: 40px;\n        padding-right: 40px;\n    }\n    \n    @media (--large) {\n        margin-bottom: 60px;\n    }\n}\n\n.header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    height: 100%;\n    max-width: 1320px;\n    margin: 0 auto;\n}\n\n.logo img {\n    width: 137px;\n    height: 32px;\n}\n\n.main {\n    max-width: 1320px;\n    width: 100%;\n    margin: 0 auto;\n\n    @media (--mobile) {\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n\n    @media (--tablet) {\n        padding-left: 40px;\n        padding-right: 40px;\n    }\n}\n\n.title {\n    font-size: 24px;\n    line-height: 28px;\n    font-weight: 500;\n    color: var(--tertiary-color);\n    text-transform: uppercase;\n    margin-bottom: 28px;\n\n    @media (--large) {\n        font-size: 40px;\n        line-height: 1.15;\n        margin-bottom: 40px;\n    }\n}\n\n.secondaryTitle {\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 1.2;\n    margin-bottom: 28px;\n    color: var(--tertiary-color);\n\n    @media (--large) {\n        font-size: 28px;\n        line-height: 1.14;\n    }\n}\n\n.secondaryTitleWithCenter {\n    text-align: center;\n    margin-bottom: 40px;\n}\n\n.section {\n    position: relative;\n    margin-bottom: 60px;\n    z-index: 2;\n}\n\n.description {\n    color: var(--tertiary-color);\n    margin-bottom: 40px;\n    text-align: center;\n\n    @media (--large) {\n        margin: 0 auto 60px;\n        max-width: 420px;\n    }\n}\n\n.sectionGrid {\n    display: grid;\n\n    @media (--mobile), (--tablet) {\n        grid-template-columns: 1fr 1fr;\n        grid-template-rows: repeat(3, max-content);\n        grid-template-areas: \"sectionInfo sectionInfo\"\n                            \"sectionImage sectionImage\"\n                            \"sectionCopyrightInfo sectionCopyrightInfo\";\n    }\n\n    @media (--desktop-only) {\n        grid-template-columns: auto 760px;\n        grid-template-rows: repeat(2, max-content);\n        grid-column-gap: 24px;\n        grid-template-areas: \"sectionInfo sectionImage\"\n                            \"sectionCopyrightInfo sectionImage\";\n    }\n\n    .sectionInfo {\n        grid-area: sectionInfo;\n    }\n\n    .sectionCopyrightInfo {\n        grid-area: sectionCopyrightInfo;\n    }\n\n    .sectionImage {\n        grid-area: sectionImage;\n    }\n}\n\n.sectionGridButton {\n    margin-bottom: 40px;\n\n    @media (--mobile) {\n        width: 100%;\n    }\n}\n\n.sectionFlexLink {\n    @media (--tiny-only) {\n        width: 100%;\n        margin-bottom: 20px;\n    }\n\n    @media (--tablet) {\n        margin-bottom: 40px;\n    }\n}\n\n.sectionLink {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: color 0.25s ease-in-out, background-color 0.25s ease-in-out;\n    white-space: nowrap;\n    text-transform: uppercase;\n    padding: 12px 48px;\n    background-color: var(--main-color);\n    color: #111319;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 16px;\n    letter-spacing: 0.02em;\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover, &:active {\n            background-color: var(--secondary-color);\n            color: #1E2028;\n        }\n    }\n}\n\n.sectionFlexButtonWrap {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n\n    @media (--tiny-only) {\n        flex-direction: column;\n        align-items: flex-start;\n        margin-bottom: 20px;\n\n        > button {\n            width: 100%;\n        }\n    }\n\n    @media (--small-tablet), (--tablet) {\n        margin-bottom: 40px;\n    }\n}\n\n.sectionFlexButtonWrapText {\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: 0.05em;\n    color: var(--secondary-color);\n    text-transform: uppercase;\n}\n\n.sectionFlex {\n    @media (--desktop-only) {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 24px;\n    }\n}\n\n.sectionColumn {\n    padding: 0 0 60px 0;\n\n    @media (--large) {\n        padding: 60px 0;\n    }\n}\n\n.sectionColumnInOnboarding {\n    padding: 0 0 60px 0;\n}\n\n.sectionCopyrightInfo {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 1.33;\n    color: #85909D;\n    border-top: 1px solid #1E2028;\n    padding-top: 16px;\n\n    @media (--mobile) {\n        margin-top: 20px;\n    }\n\n    @media (--tablet) {\n        margin-top: 40px;\n    }\n}\n\n.sectionLabel {\n    font-size: 16px;\n    line-height: 1.25;\n    font-weight: 400;\n    color: var(--tertiary-color);\n    margin-bottom: 40px;\n\n    @media (--desktop-only) {\n        margin-bottom: 64px;\n    }\n}\n\n.sectionImageWrap,\n.sectionVideoWrap {\n    width: 100%;\n    position: relative;\n\n    @media (--desktop-only) {\n        width: 760px;\n        height: 468px;\n        flex-shrink: 0;\n    }\n}\n\n.sectionImage {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 7.6 / 4.68;\n\n    @media (--desktop-only) {\n        width: 760px;\n        height: 468px;\n    }\n}\n\n.list {\n    margin-bottom: 40px;\n\n    @media (--large) {\n        padding-right: 30px;\n    }\n}\n\n.listItem {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: #85909D;\n    display: flex;\n    gap: 4px;\n}\n\n.listItemNumber {\n    color: var(--secondary-color);\n    width: 26px;\n    display: inline-flex;\n    flex-shrink: 0;\n}\n\n.textWithAnimation1 {\n    border-radius: 3px;\n    padding: 2px;\n    animation: colorTransition1 14.4s ease-in-out infinite;\n}\n\n.textWithAnimation2 {\n    border-radius: 3px;\n    padding: 2px;\n    animation: colorTransition2 14.4s ease-in-out infinite;\n}\n\n.textWithAnimation3 {\n    border-radius: 3px;\n    padding: 2px;\n    animation: colorTransition3 14.4s ease-in-out infinite;\n}\n\n.textWithAnimation4 {\n    border-radius: 3px;\n    padding: 2px;\n    animation: colorTransition4 14.4s ease-in-out infinite;\n}\n\n.textWithAnimation5 {\n    border-radius: 3px;\n    padding: 2px;\n    animation: colorTransition5 14.4s ease-in-out infinite;\n}\n\n.textWithAnimation6 {\n    border-radius: 3px;\n    padding: 2px;\n    animation: colorTransition6 14.4s ease-in-out infinite;\n}\n\n.textWithAnimation7 {\n    border-radius: 3px;\n    padding: 2px;\n    animation: colorTransition7 14.4s ease-in-out infinite;\n}\n\n.textWithAnimation8 {\n    border-radius: 3px;\n    padding: 2px;\n    animation: colorTransition8 14.4s ease-in-out infinite;\n}\n\n@keyframes colorTransition1 {\n    0% {\n        background-color: transparent;\n        color: #85909D;\n    }\n    1.4% {\n        color: #090A0E;\n        background-color: #ffffff;\n    }\n    11.1% {\n        background-color: #ffffff;\n        color: #090A0E;\n    }\n    12.5% {\n        background-color: transparent;\n        color: #85909D;\n    }\n}\n\n@keyframes colorTransition2 {\n    12.5% {\n        background-color: transparent;\n        color: #85909D;\n    }\n    13.9% {\n        color: #090A0E;\n        background-color: #ffffff;\n    }\n    23.6% {\n        color: #090A0E;\n        background-color: #ffffff;\n    }\n    25% {\n        background-color: transparent;\n        color: #85909D;\n    }\n}\n\n@keyframes colorTransition3 {\n    25% {\n        background-color: transparent;\n        color: #85909D;\n    }\n    26.4% {\n        color: #090A0E;\n        background-color: #ffffff;\n    }\n    36.1% {\n        color: #090A0E;\n        background-color: #ffffff;\n    }\n    37.5% {\n        background-color: transparent;\n        color: #85909D;\n    }\n}\n\n@keyframes colorTransition4 {\n    37.5% {\n        background-color: transparent;\n        color: #85909D;\n    }\n    38.9% {\n        color: #090A0E;\n        background-color: #ffffff;\n    }\n    48.6% {\n        color: #090A0E;\n        background-color: #ffffff;\n    }\n    50% {\n        background-color: transparent;\n        color: #85909D;\n    }\n}\n\n@keyframes colorTransition5 {\n    50% {\n        background-color: transparent;\n        color: #85909D;\n    }\n    51.4% {\n        color: #090A0E;\n        background-color: #ffffff;\n    }\n    61.1% {\n        color: #090A0E;\n        background-color: #ffffff;\n    }\n    62.5% {\n        background-color: transparent;\n        color: #85909D;\n    }\n}\n\n@keyframes colorTransition6 {\n    62.5% {\n        background-color: transparent;\n        color: #85909D;\n    }\n    63.9% {\n        color: #090A0E;\n        background-color: #ffffff;\n    }\n    73.6% {\n        color: #090A0E;\n        background-color: #ffffff;\n    }\n    75% {\n        background-color: transparent;\n        color: #85909D;\n    }\n}\n\n@keyframes colorTransition7 {\n    75% {\n        background-color: transparent;\n        color: #85909D;\n    }\n    76.4% {\n        color: #090A0E;\n        background-color: #ffffff;\n    }\n    86.1% {\n        color: #090A0E;\n        background-color: #ffffff;\n    }\n    87.5% {\n        background-color: transparent;\n        color: #85909D;\n    }\n}\n\n@keyframes colorTransition8 {\n    87.5% {\n        background-color: transparent;\n        color: #85909D;\n    }\n    88.9% {\n        color: #090A0E;\n        background-color: #ffffff;\n    }\n    98.6% {\n        color: #090A0E;\n        background-color: #ffffff;\n    }\n    100% {\n        background-color: transparent;\n        color: #85909D;\n    }\n}\n\n.tournamentList {\n    display: grid;\n    grid-gap: 24px;\n    grid-template-columns: repeat(4, minmax(312px, 1fr));\n    width: 100%;\n    scroll-snap-type: x mandatory;\n    overflow-x: auto;\n    min-height: 244px;\n\n    @media (--tiny-only) {\n        grid-template-columns: repeat(4, minmax(275px, 1fr));\n        grid-gap: 20px;\n    }\n\n    &::-webkit-scrollbar {\n        display: none;\n    }\n}\n\n/* masonryList */\n.masonryList {\n    @media (--small-tablet), (--tablet) {\n        column-count: 2;\n        column-gap: 24px;\n    }\n\n    @media (--desktop-only) {\n        column-count: 4;\n        column-gap: 24px;\n    }\n}\n\n.masonryCard {\n    background-color: #090A0E;\n    border: 1px solid #1E2028;\n    border-radius: 6px;\n    padding: 24px;\n\n    @media (--small-tablet), (--large) {\n        break-inside: avoid;\n    }\n}\n\n.questionAnswerBlock {\n    margin-bottom: 24px;\n}\n\n.masonryCardLabel {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 20px;\n    margin-bottom: 16px;\n    color: var(--tertiary-color);\n}\n\n.masonryCardValue {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 1.71;\n    color: #85909D;\n}\n\n.masonryCardLink {\n    width: 100%;\n}\n\n/* slider */\n.bullet {\n    width: 32px;\n    height: 2px;\n    border-radius: 6px;\n    background-color: var(--secondary-color);\n    opacity: 1;\n    transition: width 0.4s ease-in-out;\n    position: relative;\n    cursor: pointer;\n\n    &::after {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        top: -8px;\n        width: 100%;\n        height: 18px;\n        background-color: transparent;\n        z-index: 2;\n    }\n}\n\n.bulletActive {\n    width: 140px;\n}\n\n.glow {\n    position: absolute;\n    width: 539px;\n    height: 539px;\n    z-index: -1;\n\n    @media (--mobile), (--tablet) {\n        bottom: 0;\n        right: 50%;\n        transform: translateX(50%);\n    }\n\n    @media (--tiny-only) {\n        bottom: -100px;\n        transform: none;\n        right: -300px;\n    }\n\n    @media (--desktop-only) {\n        top: 0;\n        right: -100px;\n    }\n}\n\n.glowBlock {\n    width: 365px;\n    height: 365px;\n    border-radius: 50%;\n    background: linear-gradient(180deg, #FFBF4E 43.75%, #FF5B00 52.6%);\n    filter: blur(50px);\n    will-change: filter;\n    position: absolute;\n    z-index: -1;\n\n    @media (--mobile), (--tablet) {\n        bottom: 87px;\n        right: 50%;\n        transform: translateX(50%);\n    }\n\n    @media (--tiny-only) {\n        bottom: -13px;\n        transform: none;\n        right: -213px;\n    }\n\n    @media (--desktop-only) {\n        top: 87px;\n        right: -13px;\n    }\n}\n\n.refererPrimaryGlow {\n    position: absolute;\n    display: none;\n    z-index: -1;\n\n    @media (--large) {\n        width: 273px;\n        height: 273px;\n        bottom: -99px;\n        left: 111px;\n        display: block;\n    }\n}\n\n.refererSecondaryGlow {\n    position: absolute;\n    width: 320px;\n    height: 320px;\n    top: 0px;\n    right: -30px;\n    z-index: -1;\n\n    @media (--large) {\n        width: 151px;\n        height: 151px;\n        top: 78px;\n        right: 187px;\n    }\n}\n\n.videoGlow {\n    position: absolute;\n    width: 320px;\n    height: 320px;\n    z-index: -1;\n\n    @media (--mobile) {\n        bottom: -90px;\n        right: -110px;\n    }\n\n    @media (--large) {\n        width: 205px;\n        height: 205px;\n        bottom: -60px;\n        left: -114px;\n    }\n}\n\n/* onboarding slider */\n.onboardingBlock {\n    background: #1E2028;\n    border-radius: 6px;\n    position: relative;\n    overflow: hidden;\n}\n\n.onboardingBlockTitle {\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 24px;\n    color: var(--tertiary-color);\n    position: absolute;\n    top: 24px;\n    left: 24px;\n    z-index: 4;\n\n    @media (--small-tablet), (--large) {\n        font-size: 28px;\n        line-height: 32px;\n    }\n\n    @media (--small-tablet) {\n        width: 260px;\n    }\n\n    @media (--desktop-only) {\n        top: 48px;\n        left: 48px;\n    }\n}\n\n.onboardingBlockPagination {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    position: absolute;\n    padding: 8px;\n    background-color: #111319;\n    border-radius: 16px;\n    left: 50% !important;\n    transform: translateX(-50%);\n    bottom: 24px !important;\n    width: auto !important;\n    z-index: 4;\n\n    @media (--small-tablet), (--tablet) {\n        left: 24px !important;\n        transform: none;\n    }\n\n    @media (--desktop-only) {\n        left: 48px !important;\n        bottom: 48px !important;\n        transform: none;\n    }\n}\n\n.buttonPlay {\n    color: var(--darkest-color);\n    text-align: center;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: 0.32px;\n    padding: 20px 64px;\n    gap: 8px;\n    border-radius: 12px;\n    --icon-size: 16px;\n}\n\n/* footer */\n\n.footerWrapper {\n    width: 100%;\n    position: relative;\n    z-index: 2;\n\n    @media (--mobile) {\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n\n    @media (--tablet) {\n        padding-left: 40px;\n        padding-right: 40px;\n    }\n\n    @media (--small-tablet), (--large) {\n        padding-top: 60px;\n        padding-bottom: 60px;\n    }\n}\n\n.footerGlow {\n    position: absolute;\n    z-index: -1;\n\n    @media (--tiny-only) {\n        width: 337px;\n        height: 337px;\n        right: -192px;\n        bottom: -180px;\n    }\n\n    @media (--small-tablet) {\n        width: 400px;\n        height: 400px;\n        left: 0;\n        bottom: -250px;\n    }\n\n    @media (--large) {\n        width: 273px;\n        height: 273px;\n        left: 0;\n        bottom: -134px;\n    }\n}\n\n.footer {\n    max-width: 1320px;\n    margin: 0 auto;\n\n    @media (--small-tablet), (--large) {\n        display: grid;\n        grid-template-columns: 1fr 1fr 1fr 1fr;\n        grid-gap: 20px;\n    }\n}\n\n.footerBlock {\n    @media (--mobile) {\n        margin-bottom: 20px;\n    }\n}\n\n.footerSubTitle {\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 1.2;\n    color: var(--tertiary-color);\n    margin-bottom: 24px;\n}\n\n.footerMenuItem {\n    color: var(--tertiary-color);\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 1.71;\n    display: block;\n\n    &:not(:last-child) {\n        margin-bottom: 16px;\n    }\n}\n\n.footerLabel {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #85909D;\n    display: block;\n}\n\n.footerCopyright {\n    margin-bottom: 16px;\n    margin-top: 24px;\n}\n\n.footerLabelWithIndent {\n    margin-bottom: 32px;\n}\n\n.legalDisclaimerText {\n    color: #85909D;\n    text-transform: uppercase;\n    margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CounterStrikeHomePage__root--aMqFA`,
	"headerWrap": `CounterStrikeHomePage__headerWrap--P9A8O`,
	"header": `CounterStrikeHomePage__header--_K8MK`,
	"logo": `CounterStrikeHomePage__logo--sez2p`,
	"main": `CounterStrikeHomePage__main--FWjTH`,
	"title": `CounterStrikeHomePage__title--yNQEU`,
	"secondaryTitle": `CounterStrikeHomePage__secondaryTitle--PgNLf`,
	"secondaryTitleWithCenter": `CounterStrikeHomePage__secondaryTitleWithCenter--xuvUC`,
	"section": `CounterStrikeHomePage__section--ONeHH`,
	"description": `CounterStrikeHomePage__description--kBKNf`,
	"sectionGrid": `CounterStrikeHomePage__sectionGrid--Jt3Nd`,
	"sectionInfo": `CounterStrikeHomePage__sectionInfo--pUpUq`,
	"sectionCopyrightInfo": `CounterStrikeHomePage__sectionCopyrightInfo--cJTy2`,
	"sectionImage": `CounterStrikeHomePage__sectionImage--pyrWL`,
	"sectionGridButton": `CounterStrikeHomePage__sectionGridButton--b3sWx`,
	"sectionFlexLink": `CounterStrikeHomePage__sectionFlexLink--c8uoC`,
	"sectionLink": `CounterStrikeHomePage__sectionLink--Rduub`,
	"sectionFlexButtonWrap": `CounterStrikeHomePage__sectionFlexButtonWrap--lysUl`,
	"sectionFlexButtonWrapText": `CounterStrikeHomePage__sectionFlexButtonWrapText--oueTE`,
	"sectionFlex": `CounterStrikeHomePage__sectionFlex--WVEya`,
	"sectionColumn": `CounterStrikeHomePage__sectionColumn--ayREv`,
	"sectionColumnInOnboarding": `CounterStrikeHomePage__sectionColumnInOnboarding--QDobp`,
	"sectionLabel": `CounterStrikeHomePage__sectionLabel--pMLa6`,
	"sectionImageWrap": `CounterStrikeHomePage__sectionImageWrap--EQnqY`,
	"sectionVideoWrap": `CounterStrikeHomePage__sectionVideoWrap--EJb4o`,
	"list": `CounterStrikeHomePage__list--g2cmZ`,
	"listItem": `CounterStrikeHomePage__listItem--INeXY`,
	"listItemNumber": `CounterStrikeHomePage__listItemNumber--pVf7R`,
	"textWithAnimation1": `CounterStrikeHomePage__textWithAnimation1--JjuAv`,
	"colorTransition1": `CounterStrikeHomePage__colorTransition1--Z5J6v`,
	"textWithAnimation2": `CounterStrikeHomePage__textWithAnimation2--x4QXn`,
	"colorTransition2": `CounterStrikeHomePage__colorTransition2--btLby`,
	"textWithAnimation3": `CounterStrikeHomePage__textWithAnimation3--hxCjO`,
	"colorTransition3": `CounterStrikeHomePage__colorTransition3--wJRon`,
	"textWithAnimation4": `CounterStrikeHomePage__textWithAnimation4--MBCXX`,
	"colorTransition4": `CounterStrikeHomePage__colorTransition4--EPaDy`,
	"textWithAnimation5": `CounterStrikeHomePage__textWithAnimation5--XS7eL`,
	"colorTransition5": `CounterStrikeHomePage__colorTransition5--oP8Sf`,
	"textWithAnimation6": `CounterStrikeHomePage__textWithAnimation6--kkTMv`,
	"colorTransition6": `CounterStrikeHomePage__colorTransition6--vrnwc`,
	"textWithAnimation7": `CounterStrikeHomePage__textWithAnimation7--gHsqf`,
	"colorTransition7": `CounterStrikeHomePage__colorTransition7--gbxko`,
	"textWithAnimation8": `CounterStrikeHomePage__textWithAnimation8--HrgDI`,
	"colorTransition8": `CounterStrikeHomePage__colorTransition8--ekYED`,
	"tournamentList": `CounterStrikeHomePage__tournamentList--MJWCk`,
	"masonryList": `CounterStrikeHomePage__masonryList--vtYIW`,
	"masonryCard": `CounterStrikeHomePage__masonryCard--T1HSE`,
	"questionAnswerBlock": `CounterStrikeHomePage__questionAnswerBlock--eqT5L`,
	"masonryCardLabel": `CounterStrikeHomePage__masonryCardLabel--qFWvp`,
	"masonryCardValue": `CounterStrikeHomePage__masonryCardValue--oRPdI`,
	"masonryCardLink": `CounterStrikeHomePage__masonryCardLink--D3bVQ`,
	"bullet": `CounterStrikeHomePage__bullet--mmqVO`,
	"bulletActive": `CounterStrikeHomePage__bulletActive--huBXu`,
	"glow": `CounterStrikeHomePage__glow--_dRW6`,
	"glowBlock": `CounterStrikeHomePage__glowBlock--_pDaO`,
	"refererPrimaryGlow": `CounterStrikeHomePage__refererPrimaryGlow--PC93b`,
	"refererSecondaryGlow": `CounterStrikeHomePage__refererSecondaryGlow--ddUYK`,
	"videoGlow": `CounterStrikeHomePage__videoGlow--RQo7h`,
	"onboardingBlock": `CounterStrikeHomePage__onboardingBlock--hZnnY`,
	"onboardingBlockTitle": `CounterStrikeHomePage__onboardingBlockTitle--f6heH`,
	"onboardingBlockPagination": `CounterStrikeHomePage__onboardingBlockPagination--gEGYG`,
	"buttonPlay": `CounterStrikeHomePage__buttonPlay--rH0H4`,
	"footerWrapper": `CounterStrikeHomePage__footerWrapper--DT4kA`,
	"footerGlow": `CounterStrikeHomePage__footerGlow--VGC7t`,
	"footer": `CounterStrikeHomePage__footer--lZvIy`,
	"footerBlock": `CounterStrikeHomePage__footerBlock--RV6ES`,
	"footerSubTitle": `CounterStrikeHomePage__footerSubTitle--Yxfph`,
	"footerMenuItem": `CounterStrikeHomePage__footerMenuItem--hZ0GH`,
	"footerLabel": `CounterStrikeHomePage__footerLabel--jfDil`,
	"footerCopyright": `CounterStrikeHomePage__footerCopyright--nkj02`,
	"footerLabelWithIndent": `CounterStrikeHomePage__footerLabelWithIndent--Ja5Ui`,
	"legalDisclaimerText": `CounterStrikeHomePage__legalDisclaimerText--fjVOc`
};
export default ___CSS_LOADER_EXPORT___;
